export default __webpack_public_path__ + "static/media/likeDark.5d88b1f2.svg";